import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppErrorService {
  /** When true, the App component replaces all chrome (header, navbar, content) with an error page */
  readonly hasApiError = signal(false);

  setNotProvisionedError(): void {
    this.hasApiError.set(true);
  }

  clearError(): void {
    this.hasApiError.set(false);
  }
}
